import { render } from "./StepForm2.vue?vue&type=template&id=6fcd22e0&scoped=true"
import script from "./StepForm2.vue?vue&type=script&lang=js"
export * from "./StepForm2.vue?vue&type=script&lang=js"

import "./StepForm2.vue?vue&type=style&index=0&id=6fcd22e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcd22e0"]])

export default __exports__